// import Vue from 'vue'

require('./bootstrap')

import route from 'ziggy'
import { Ziggy } from './ziggy'

window.Vue = require('vue')

Vue.mixin({
  methods: {
    route: (name, params, absolute) => route(name, params, absolute, Ziggy)
  }
})

Vue.component('pagination', require('laravel-vue-pagination'))

Vue.component('users-filter-component', require('./components/UsersFilterComponent.vue').default)

Vue.component('date-interval-picker-component', require('./components/DateIntervalPickerComponent.vue').default)

const app = new Vue({
  el: '#app',
})
